import * as React from "react";
import { ThemedEventConstants } from "../../constants/ThemedEventConstants";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonPrimaryMedium } from "../generic/common/ButtonPrimaryMedium";
import { IdIcon } from "../generic/icon/IdIcon";
import { ProgressBar } from "../generic/progress-bar/ProgressBar";
import { TextLoca } from "../generic/text/TextLoca";
import { ButtonGoto } from "../tournament-building/ButtonGoto";
import { ThemedEventQuestsRewardIcons } from "./ThemedEventQuestsRewardIcons";
export var ThemedEventProgress = function (_a) {
    var activeQuestEpisode = _a.activeQuestEpisode, locaReplacements = _a.locaReplacements, taskIcons = _a.taskIcons, onGoToClick = _a.onGoToClick;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "h100 flex flex--stacked flex--around" },
            React.createElement(ProgressBar, { backgroundClassName: "" + IdStyles.EventProgressBarBackground, fillClassName: IdStyles.EventProgressBarFill, progressPercent: (activeQuestEpisode * 100) / ThemedEventConstants.eventTotalEpisodes },
                React.createElement(TextLoca, { id: IdLoca.taskX_of_Y, className: IdStyles.TextNormal, replacements: locaReplacements })),
            React.createElement(ThemedEventQuestsRewardIcons, { taskIcons: taskIcons, activeQuestEpisode: activeQuestEpisode })),
        React.createElement(ButtonGoto, { onClick: onGoToClick, buttonType: ButtonPrimaryMedium, destinationIcon: IdIcon.QuestbookIcn })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/ThemedEventProgress.tsx
// module id = 2769
// module chunks = 3